import script from "./TablaInscritosMas.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaInscritosMas.vue?vue&type=script&setup=true&lang=ts"

import "./TablaInscritosMas.vue?vue&type=style&index=0&id=134bc0d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134bc0d0"]])

export default __exports__